import React, { ReactElement } from 'react';
import './DesktopRating.scss';
import { Readable } from '../../../../Models/Product/Readable';
import { Genre } from '../../../../Models/Series';
import dayjs from 'dayjs';
import { TryParseTrimText } from '../../../../Devon/MathFractions';


const tableTitles = [
    'Rating',
    'Pages',
    'Status',
    'Print Release',
    'Print Format',
    'ISBN',
    'Dimensions',
    'E-Book Release',
    'EISBN',
];

interface TagsProps {
    readable: Readable;
    ageRating: string;
    trim?: string;
}

const twoColumnFlex = (title: string, value: string | number): ReactElement => {
    return <div key={title} className={'product-desktop-rating-table-title-value-wrapper'}>
        <div className={'product-desktop-rating-table-title-wrapper'}>
            <span className={'product-desktop-rating-table-title'}>{title}:</span>
        </div>

        {
            title===`Dimensions`?(
                <div className={'product-desktop-rating-table-value-wrapper'}>
                    <span className={'product-desktop-rating-table-title'}>{TryParseTrimText(value as string).result}</span>
                </div>
            ):(
                <div className={'product-desktop-rating-table-value-wrapper'}>
                    <span className={'product-desktop-rating-table-title'}>{value}</span>
                </div>
            )}

    </div>;
};

const thirdRowGenerator = (title: string, genres: Genre[]): ReactElement => {
    return <div className='product-desktop-rating-table-tags-tags-container'>
        <span className='product-desktop-rating-table-tags-tag-text'>{title!!}</span>
        <div className='product-desktop-rating-table-tags-tags-wrapper'>
            {genres?.map((tag) => {
                return <span key={tag.id}
                             className='product-desktop-rating-table-tags-tag'>{tag?.name}</span>;
            })}
        </div>
    </div>;
};

const DesktopRating = ({ readable, ageRating, trim }: TagsProps): ReactElement => {
    const tableValues = [ageRating!!, readable?.pageCount, readable?.imprint,
        readable?.printReleaseDate?.format('MMM D, YYYY'),
        readable?.coverType,
        readable?.isbn,
        trim,
        readable?.digitalReleaseDate?.format('MMM D, YYYY'),
        readable?.eisbn];


    const isbnExists = tableValues[5];
    const eisbnExists = tableValues[8];

    console.log('printDataExists', isbnExists);
    return (
        <div className='product-desktop-rating-table-container'>
            <table className='product-desktop-rating-table'>

                <tbody>

                <tr>
                    <div className={'product-desktop-rating-table-first-row-wrapper'}>
                        <div className={'product-desktop-rating-table-second-row-inner-wrapper'}>
                            {twoColumnFlex(tableTitles[0], tableValues[0])}
                        </div>
                        <div className='divider' />

                        <div className={'product-desktop-rating-table-second-row-inner-wrapper'}>
                            {twoColumnFlex(tableTitles[1], tableValues[1])}
                        </div>
                        {/*<div className='divider' />*/}

                        {/*<div className={'product-desktop-rating-table-second-row-inner-wrapper'}>*/}
                        {/*{twoColumnFlex(tableTitles[2], tableValues[2])}*/}
                        {/* We don't have status in the data */}
                        {/*{twoColumnFlex(tableTitles[2], 'COMPLETED')}*/}
                        {/*</div>*/}
                    </div>
                </tr>

                <tr>
                    <div className={'product-desktop-rating-table-second-row-wrapper'}>
                        {isbnExists !== '' &&
                            <div className={'product-desktop-rating-table-second-row-inner-wrapper'}>
                                {tableTitles.slice(3, 7)
                                    ?.map((title, index) => ({ title, value: tableValues[index + 3] }))
                                    .filter(({ value }) => !!value)
                                    .map(({ title, value }) => twoColumnFlex(title, value))}
                            </div>
                        }

                        {isbnExists !== '' && eisbnExists !== '' &&
                            <div className='divider' />}

                        {eisbnExists !== '' && <div className={'product-desktop-rating-table-second-row-inner-wrapper'}>
                            {tableTitles.slice(7, 9)?.map((title, index) => {
                                return twoColumnFlex(title, tableValues[index + 7]);
                            })}
                        </div>}
                    </div>
                </tr>
                <tr>
                    <div className={'product-desktop-rating-table-third-row-wrapper'}>
                        {thirdRowGenerator('Tags', readable?.genres)}
                        {/*<div className='divider' />*/}
                        {/*{thirdRowGenerator('Content Warning', readable.genres)}*/}
                    </div>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default DesktopRating;